export const CONFIG_ENVIRONMENT = 'REPLACE:CONFIG_ENVIRONMENT';

// Default Permission Client config.
export const CONFIG_VERSION = 'REPLACE:CONFIG_APP_VERSION';

// Google AC config
export const CONFIG_GOOGLE_AC_VERSION = 1;
export const CONFIG_GOOGLE_AC_VENDOR_IDS = 'REPLACE:CONFIG_GOOGLE_VENDOR_IDS';

// Cookie
export const CONFIG_IAB_TCF_COOKIE_IDENTIFIER = 'euconsent-v2';
export const COOKIE_IDENTIFIER_IDCC = 'idcc';
export const COOKIE_IDENTIFIER_DEBUG = 'TCF_API_DEBUG';

// IAB / TCF Config
export const CONFIG_IAB_TCF_CMP_ID = 167;
export const CONFIG_IAB_TCF_CMP_VERSION = 2;
export const CONFIG_IAB_TCF_SERVICE_SPECIFIC = true;

// Vendor IDs
export const CONFIG_IAB_TCF_VENDOR_ADOBE                        = 565;
export const CONFIG_IAB_TCF_VENDOR_INDEX_EXCHANGE               = 10;
export const CONFIG_IAB_TCF_VENDOR_AGOF_DAILY_CAMPAIGN_FACTS    = 722;
export const CONFIG_IAB_TCF_VENDOR_AGOF_DAILY_DIGITAL_FACTS     = 785;
export const CONFIG_IAB_TCF_VENDOR_INFONLINE                    = 730;
export const CONFIG_IAB_TCF_VENDOR_XANDR                        = 32;
export const CONFIG_IAB_TCF_VENDOR_CRITEO                       = 91;
export const CONFIG_IAB_TCF_VENDOR_ADITION                      = 39;
export const CONFIG_IAB_TCF_VENDOR_ACTIVE_AGENT                 = 40;
export const CONFIG_IAB_TCF_VENDOR_YIELDLAB                     = 70;
export const CONFIG_IAB_TCF_VENDOR_GOOGLE                       = 755;
export const CONFIG_IAB_TCF_VENDOR_PUBMATIC                     = 76;
export const CONFIG_IAB_TCF_VENDOR_SMART_ADSERVER               = 45;
export const CONFIG_IAB_TCF_VENDOR_OPEN_X                       = 69;
export const CONFIG_IAB_TCF_VENDOR_IMPROVE_DIGITAL              = 253;
export const CONFIG_IAB_TCF_VENDOR_RUBICON                      = 52;
export const CONFIG_IAB_TCF_VENDOR_PLISTA                       = 177;
export const CONFIG_IAB_TCF_VENDOR_AD_DEFEND                    = 539;
export const CONFIG_IAB_TCF_VENDOR_TABOOLA                      = 42;
export const CONFIG_IAB_TCF_VENDOR_AMAZON                       = 793;
export const CONFIG_IAB_TCF_VENDOR_VERIZON                      = 25;
export const CONFIG_IAB_TCF_VENDOR_DPAG                         = 735;
export const CONFIG_IAB_TCF_VENDOR_INTELLI_AD                   = 852;
